module.exports = "import { Docs } from \"../../lib\";\nimport React from \"react\";\n\nconst params = [\n  {\n    \"type\": {\n      \"names\": [\n        \"string\"\n      ]\n    },\n    \"description\": \"name of the component to be demoed\",\n    \"name\": \"label\"\n  }\n];\n\nexport default () => (\n  <Docs\n    label=\"Demo\"\n    description=\"I'm in a Showcase!\"\n    params={params} />);\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/Docs/demo/SimpleUsage.js
// module id = 131
// module chunks = 0